import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { ApplicationContainer } from 'marty'
import {
  installWidgetStub,
  installSegment,
  hideWelcomeMessage,
  waitForUserJwt,
} from 'app/Helpers'
import { Router } from 'react-router'

class MartyApp extends Component {
  render() {
    const { app, history, routes } = this.props
    return (
      <ApplicationContainer app={app}>
        <Router history={history} routes={routes} />
      </ApplicationContainer>
    )
  }
}

class AppContainer extends Component {
  componentDidMount() {
    window.__DRIFT__recordBootstrapCheckpoint('AppContainer.componentDidMount')
    installWidgetStub()
    waitForUserJwt()
    installSegment()
    hideWelcomeMessage()
  }

  render() {
    const { app, history, store, routes } = this.props
    return (
      <Provider store={store}>
        <MartyApp app={app}
                  history={history}
                  routes={routes} />
      </Provider>
    )
  }
}

export default AppContainer



// WEBPACK FOOTER //
// ./src/scripts/containers/AppContainer.js